var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticpairing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 35,
    cy: 28.3,
    r: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M35.6 20.9c.1-8-6.3-14.6-14.3-14.7-3.9-.1-7.4 1.1-10 3.5-2.3 2.2-2.5 2.7-2.5 2.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.6 32c-2.6 2.6-6.3 4.3-10.3 4.2-8 0-14.5-6.5-14.5-14.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M40 18.8l-4.4 4.3-4.4-4.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M2.4 22.5l4.4-4.4 4 4.4M14.1 27.8l7.2-14.4 6.1 14.4M24.8 23.7h-8.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.1 27.8l7.2-14.4 6.1 14.4M24.8 23.7h-8.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticpairing);
export default __webpack_public_path__ + "static/media/automaticpairing.b7edefb7377a4960a175692c83f60c0d.svg";
export { ForwardRef as ReactComponent };